<template>
  <div class="layout-menu-container">
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
    />
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";

export default {
  props: {
    model: Array,
  },
  methods: {
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
  },
  components: {
    AppSubmenu: AppSubmenu,
  },
};
</script>

<style>
  .menuitem-badge {
    padding-right: 1px !important;
    width: 18px !important;
    height: 18px !important;
    line-height: 18px !important;
    margin-left: 7px !important;
    background-color: #EF4444 !important;
  }
</style>